import { PettyCashListPage } from '@/features/petty-cash/pages/PettyCashListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/petty-cash/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["petty_cash.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PettyCashListPage,
})
